import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';

import './AdminSession.scss';
import RetailPage from 'src/containers/Page/RetailPage';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import Button from 'src/components/Button/Button';
import { RootState } from 'src/configs/store';
import TillHistory from '../Transactions/components/TillHistory/TillHistory';
import ModalSession from './ModaslSession/ModalSession';
import BalanceModal from './ModaslSession/BalanceModal';
import TransferModal from './ModaslSession/TransferModal';
import ModalContainer from './ModaslSession/ModalContainer';
import TransactionByGroup from './ModaslSession/TransactionByGroup';
import UserBalance from './ModaslSession/UserBalance';
import Icon from 'src/components/Icon/Icon';
import classNames from 'classnames';
import SessionAddTransaction from './ModaslSession/SessionAddTransaction';

function AdminSession() {
  const { t } = useTranslation();
  const [sessionId, setSessionId] = useState('');
  const [sessionDetails, setSessionDetails] = useState(null);
  const [userBalance, setUserBalance] = useState([]);
  const [comments, setComments] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [sessionBalance, setSessionBalance] = useState(null);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [sessionDetailsModal, setSessionDetailsModal] = useState(false);
  const [cashupModal, setCashupModal] = useState(false);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [addTransactionModal, setAddTransactionModal] = useState(false);
  const [transactionByGroup, setTransactionByGroup] = useState(false);
  const [userBalanceModal, setUserBalanceModal] = useState(false);
  const [information, setInformation] = useState([1, 2, 3, 4, 5, 6]);

  const { transactionTypeList } = useSelector((state:RootState) => state.account);
  const { sessionApproval } = useSelector((state:RootState) => state.peripherals);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!sessionApproval && localStorage.getItem('fakeTill') !== 'true'){
      history.goBack();
    }
  }, [sessionApproval]);

  const fetchSession =async (e=null) => {
    if (e){
      e.preventDefault();
    }

    const session = await dispatch.peripherals.getSessionDetails({ sessionId });
    if (session && session.length > 0){
      setSessionDetails(null);
      setSessionDetails(session[0]?.till_session[0]);
    }

    if (_.isEmpty(transactionTypeList)){
      await dispatch.account.getTransactionTypes();
    }

    const balance = await dispatch.peripherals.getSessionBalance({ sessionId });

    if (balance){
      setUserBalance(balance.userBalance);
      const getBalance = _.find(balance.userBalance, { typeCode: 71 });
      if (getBalance && getBalance.balance !== 0){
        setShowButton(true);
        setShowTransferModal(true);
      } else {
        setShowButton(false);
      }
      setSessionBalance(balance);
    }
  };

  const fetchByQuery = async (id) => {
    const session = await dispatch.peripherals.getSessionDetails({ sessionId: id });

    if (session && session.length > 0){
      setSessionDetails(null);
      setSessionDetails(session[0].till_session[0]);
    }

    if (_.isEmpty(transactionTypeList)){
      await dispatch.account.getTransactionTypes();
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const queryId = query.get('session');

    if (queryId && sessionId === ''){
      setSessionId(queryId);
      fetchByQuery(queryId);
    }
  }, []);

  useEffect(() => {
    if (sessionBalance && sessionBalance.userBalance){
      const getBalance = _.find(sessionBalance.userBalance, { typeCode: 71 });
      if (getBalance && getBalance.balance !== 0){
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    }
  }, [sessionBalance]);

  const handleValueChange = (id, value, type) => {
    const newArray = JSON.parse(JSON.stringify(sessionDetails.tillSessionData));
    const index = _.findIndex(newArray, { id });
    if (type === 'numberOfNotes'){
      newArray[index]['approvedAmount'] = (+value) * (+(newArray[index].singleValue));
    } else if (type === 'approvedAmount'){
      newArray[index]['numberOfNotes'] = (+value) / (+(newArray[index].singleValue));
    }
    newArray[index][type] = value;
    setSessionDetails({ ...sessionDetails, tillSessionData:newArray });
  };

  const checkBalance = () => {
    if (sessionDetails && sessionDetails.tillSessionData){

      const amount = sessionDetails.tillSessionData.reduce((accumulator, value) => {
        if (value['isCashTotal']){
          return accumulator + +(value.approvedAmount);
        }
        return accumulator + 0;
      }, 0);
      const balance = !_.isNaN((+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount))) &&
    (+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount) / 100).toFixed(2)
    || 0;
      return +amount - +balance;
    }
    return 0;
  };

  const handleSubmission = async () => {
    // eslint-disable-next-line no-constant-condition
    if (false){
      setShowBalanceModal(true);
    } else {
      const payload = {
        denominations: _.compact(_.map(sessionDetails.tillSessionData, (data) => {
          if (data.approvedAmount > 0){
            return {
              id: data.id,
              approvedAmount: data.approvedAmount,
              ...(data.info && { info: data.info })
            };
          } else {
            return null;
          }
        })),
        sessionId
      };

      const submit = await dispatch.peripherals.approveShift(payload);

      if (submit){
        setShowModal(true);
      }
    }
  };

  const handleSubmit = async () => {
    // eslint-disable-next-line no-constant-condition
    if (false){
      setShowBalanceModal(true);
    } else {
      const balance = checkBalance();

      let comment = 'balanced';

      if (balance > 0){
        comment = 'over';
      } else if (balance < 0){
        comment = 'short';
      }

      const payload = {
        denominations: _.compact(_.map(sessionDetails.tillSessionData, (data) => {
          if (data.approvedAmount > 0){
            return {
              id: data.id,
              approvedAmount: data.approvedAmount,
              ...(data.info && { info: data.info })
            };
          } else {
            return null;
          }
        })),
        approvedInfo: `${ comment } - ${ comments }`,
        approvedByUserId: localStorage.getItem('tilluserId'),
        sessionId
      };

      if (balance !== 0){
        const tillSession = localStorage.getItem('tillSession');
        localStorage.setItem('tillSession', sessionId);

        if (balance > 0){
          await dispatch.peripherals.getAutoTransactionPayload({ id: 4, amount: Math.abs(balance) });
        }

        if (balance < 0){
          await dispatch.peripherals.getAutoTransactionPayload({ id: 3, amount: Math.abs(balance) });
        }
        localStorage.setItem('tillSession', tillSession);
      }
      const submit = await dispatch.peripherals.approveShift(payload);

      if (submit){
        await fetchSession();
        setShowModal(false);
      }
    }
  };
  let sumApproved = 0;
  let sum = 0;

  sumApproved = sessionDetails ? (_.filter(sessionDetails.tillSessionData, (bill) => bill.isCashTotal)).reduce((accumulator, bill) => {
    if (bill.amount){
      return (accumulator +(+bill.amount));
    }
    return accumulator + 0;
  }, 0) : 0;

  sum = sessionDetails ? (_.filter(sessionDetails.tillSessionData, (bill) => bill.isCashTotal)).reduce((accumulator, bill) => {
    if (bill.approvedAmount){
      return (accumulator +(+bill.approvedAmount));
    }
    return accumulator + 0;
  }, 0) : 0;

  const addTransaction = async () => {
    setShowButton(false);
    const amount = !_.isNaN((+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount))) &&
    (+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount) / 100).toFixed(2)
    || 0;

    const tillSession = localStorage.getItem('tillSession');

    localStorage.setItem('tillSession', sessionId);
    await dispatch.peripherals.getAutoTransactionPayload({ id: 2, amount: +amount });
    localStorage.setItem('tillSession', tillSession);

    setShowButton(false);
    setShowTransferModal(false);
  };

  const handleComments = useCallback((value) => {
    setComments(value);
  }, []);

  const checkBreadcrumb = () => {
    if (sessionDetails){
      return [{ name: t('retail.home'), link:'/' }, { name: t('adminSession.adminSession'), link: '/session-admin', reloadOnClick: true },
        { name: sessionDetails.sessionId, link: ''  }];
    }
    return [{ name: t('retail.home'), link:'/' }, { name: t('adminSession.adminSession'), link: ''  }];
  };

  const checkInformation = (number: number) => {
    if (information.includes(number)){
      const newInfo = _.filter(information, (infoNumber) => {
        return infoNumber !== number;
      });
      setInformation(newInfo);
    } else {
      setInformation([...information, number]);
    }
  };

  return (
    <RetailPage>
      <BreadCrumb breadcrumbs={ checkBreadcrumb() } />
      <div className="session">
        <form className="session__form" onSubmit={ !sessionDetails ? fetchSession : () => {} }>
          <div className="session__id-container">
            {
              !sessionDetails &&
              <>
                <label className="session__label">{ t('adminSession.sessionId') }</label>
                <input type="text" className="session__input" value={ sessionId } onChange={ (e) => setSessionId(e.target.value) } /><button
                  type="submit"
                  className="session__submit session__submit--small"
                  disabled={ sessionId === '' }
                >{ t('adminSession.getSession') }</button>
              </>
            }
            {
              (showButton && sessionDetails) && !(sessionDetails.approvedBy[0]?.name) &&
              <button
                type="button"
                onClick={ () => setShowTransferModal(true) }
                className="session__submit session__submit--small"
                disabled={ !showButton }
              >{ t('adminSession.transferToUser') }</button>
            }
          </div>
        </form>
        {
          sessionDetails &&
          <div className="session__launcher">
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.sessionOverview') }</div>
              <div className="session__launcher-plus" onClick={ () => setSessionDetailsModal(true) }>+</div>
            </div>
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.cashUp') }</div>
              <div className="session__launcher-plus" onClick={ () => setCashupModal(true) }>+</div>
            </div>
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.addTransaction') }</div>
              <div className="session__launcher-plus" onClick={ () => setAddTransactionModal(true) }>+</div>
            </div>
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.balances') }</div>
              <div className="session__launcher-plus" onClick={ () => setUserBalanceModal(true) }>+</div>
            </div>
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.transactionHistory') }</div>
              <div className="session__launcher-plus" onClick={ () => setShowTransactionModal(true) }>+</div>
            </div>
            <div className="session__modal-launcher">
              <div className="session__launcher-title">{ t('adminSession.transactionByGroup') }</div>
              <div className="session__launcher-plus" onClick={ () => setTransactionByGroup(true) }>+</div>
            </div>
          </div>
        }
        {
          sessionDetails &&

            <div className="session__info">
              {
                sessionDetailsModal &&
                <ModalContainer title={ t('adminSession.sessionOverview') } handleClose={ () => setSessionDetailsModal(false) }>
                  <div className="session__overview-modal-container">
                    <div className="session__overview">
                      <div className="session__subtitle-container" onClick={ () => checkInformation(1) }>

                        <h4 className="session__title">{ t('adminSession.sessionOverview') }</h4>
                        <Icon
                          icon="arrow"
                          className={
                            classNames('combinations-container__dropdown-arrow',
                              { 'session__dropdown-arrow--opened': information.includes(1),
                                'session__dropdown-arrow': !information.includes(1)
                              })
                          }
                        />
                      </div>
                      {
                        information.includes(1) &&
                        <div className="session__information">
                          <span>{ t('adminSession.sessionId') }</span>
                          <span>{ sessionDetails.sessionId }</span>
                          <span>{ t('adminSession.sessionStarted') }</span>
                          <span>{ format((sessionDetails.startedAtClock * 1000), 'dd/MM / HH:mm') }</span>
                          <span>{ t('adminSession.sessionEnded') }</span>
                          <span>{ format((sessionDetails.stoppedAtClock * 1000), 'dd/MM / HH:mm') }</span>
                          <span>{ t('adminSession.till') }</span>
                          <span>{ `${ sessionDetails.tillCode } - ${ sessionDetails.tillName }` }</span>
                          <span>{ t('adminSession.company') }</span>
                          <span>{ `${ sessionDetails.companyCode } - ${ sessionDetails.companyName }` }</span>
                          <span>{ t('adminSession.shop') }</span>
                          <span>{ `${ sessionDetails.shopCode } - ${ sessionDetails.shopName }` }</span>
                          <span>{ t('adminSession.startedBy') }</span>
                          <span>{ `${ sessionDetails.startedBy[0].id } - ${ sessionDetails.startedBy[0].name }` }</span>
                          <span>{ t('adminSession.stoppedBy') }</span>
                          <span>{ `${ sessionDetails.stoppedBy[0]?.id || '' } - ${ sessionDetails.stoppedBy[0]?.name || '' }` }</span>
                          <span>{ t('adminSession.approvedAt') }</span>
                          <span>{ sessionDetails.approvedAt ? format(sessionDetails.approvedAtClock * 1000, 'dd/MM / HH:mm') : '' }</span>
                          <span>{ t('adminSession.approvedBy') }</span>
                          <span>{ sessionDetails.approvedBy[0]?.name ? sessionDetails.approvedBy[0].name : '' }</span>
                        </div>
                      }

                    </div>
                    <div className="session__overview">
                      <div className="session__subtitle-container" onClick={ () => checkInformation(2) }>
                        <h4 className="session__title">{ t('adminSession.lastTransactions') }</h4>
                        <Icon
                          icon="arrow"
                          className={
                            classNames('combinations-container__dropdown-arrow',
                              { 'session__dropdown-arrow--opened': information.includes(2),
                                'session__dropdown-arrow': !information.includes(2)
                              })
                          }
                        />
                      </div>
                      {
                        information.includes(2) && <div className="session__information">
                          <span>{ t('adminSession.amount') }</span>
                          <span>{
                            sessionDetails.lastTransactions && !_.isNaN((+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount))) &&
                   (+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount) / 100).toFixed(2)
                   || '-'
                          }</span>
                          <span>{ t('adminSession.balance') }</span>
                          <span>{
                            sessionDetails.lastTransactions && !_.isNaN((+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.balance))) &&
                   (+(sessionDetails.lastTransactions[0]?.transactionInfo[0]?.balance) / 100).toFixed(2)
                   || '-'
                          }</span>
                        </div>
                      }

                    </div>
                  </div>

                </ModalContainer>
              }
              {
                cashupModal &&
                <ModalContainer title={ t('adminSession.cashUpApproval') } handleClose={ () => setCashupModal(false) }>
                  <div className="session__overview-denoms">
                    <div className="session__subtitle-container" onClick={ () => checkInformation(3) }>
                      <h4 className="session__title">{ t('adminSession.denominations') }</h4>
                      <Icon
                        icon="arrow"
                        className={
                          classNames('combinations-container__dropdown-arrow',
                            { 'session__dropdown-arrow--opened': information.includes(3),
                              'session__dropdown-arrow': !information.includes(3)
                            })
                        }
                      />
                    </div>
                    {
                      information.includes(3) &&
                      <div className="session__denoms-container">
                        <div className="session__values">
                          <span />
                          <span className="session__table-title">{ t('adminSession.approvedCount') }</span>
                          <span className="session__table-title">{ t('adminSession.approvedValue') }</span>
                          <span className="session__table-title">{ t('adminSession.comment') }</span>
                          <span className="session__table-title">{ t('adminSession.submittedValue') }</span>
                        </div>
                        {
                          _.map(_.sortBy(sessionDetails.tillSessionData, 'sortId'), (data) => {
                            if (data.id){
                              return (
                                <div className="session__values">
                                  <span className="session__table-title">{ data.text }</span>
                                  {
                                    data.isInputCount && <input
                                      className="session__input session__input--value"
                                      onChange={ (e) => handleValueChange(data.id, e.target.value, 'numberOfNotes') }
                                      value={ data.numberOfNotes || '' }
                                    />
                                  }
                                  {
                                    !data.isInputCount && <span />
                                  }
                                  {
                                    data.isInputAmount && <input
                                      className="session__input session__input--value"
                                      onChange={ (e) => handleValueChange(data.id, e.target.value, 'approvedAmount') }
                                      value={ data.approvedAmount }
                                    />
                                  }
                                  {
                                    !data.isInputAmount && <span />
                                  }
                                  <input
                                    className="session__input session__input--value"
                                    onChange={ (e) => handleValueChange(data.id, e.target.value, 'info') }
                                    value={ data.info || '' }
                                  />
                                  <span>{ data.amount ? +(data.amount) : 0 }</span>
                                </div>
                              );
                            } else {
                              delete sessionDetails.tillSessionData;
                              return null;
                            }
                          })
                        }
                        <div className="session__values">
                          <span className="session__table-title">{ t('endShift.total') }</span>
                          <span />
                          <span>{ sum }</span>
                          <span />
                          <span>{ sumApproved }</span>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="session__comments">
                    <div className="session__values session__values--full">
                      <Button
                        type="button"
                        text={ t('adminSession.close') }
                        className="session__close-button"
                        onClick={ () => setCashupModal(false) }
                      />
                      {
                        !(sessionDetails.approvedBy[0]?.name) &&
                        <Button
                          type="button"
                          text={ t('adminSession.submit') }
                          className="session__approve-button"
                          onClick={ handleSubmission }
                        />
                      }
                    </div>
                  </div>
                </ModalContainer>
              }
            </div>
        }
        {
          addTransactionModal &&
          <ModalContainer title={ t('adminSession.addTransaction') } handleClose={ () => setAddTransactionModal(false) } size="wide">
            <SessionAddTransaction showButton={ false } />
          </ModalContainer>
        }
        {
          sessionDetails && showTransactionModal &&
          <ModalContainer title={ t('adminSession.transactionHistory') } handleClose={ () => setShowTransactionModal(false) } size="wide">
            <div className="session__footer">
              <TillHistory loginTime={ sessionDetails.startedAtClock } adminSession={ sessionId } defaultOrder="Desc" />
            </div>
          </ModalContainer>
        }
        {
          sessionDetails && transactionByGroup &&
          <ModalContainer title={ t('adminSession.transactionByGroup') } handleClose={ () => setTransactionByGroup(false) } size="wide">
            <div className="session__footer">
              <TransactionByGroup groups={ sessionBalance.balances } />
            </div>
          </ModalContainer>
        }
        {
          userBalanceModal &&
          <ModalContainer title={ t('adminSession.userBalance') } handleClose={ () => setUserBalanceModal(false) } size="wide">
            <div className="session__footer">
              <UserBalance balances={ userBalance } />
            </div>
          </ModalContainer>
        }
        {
          showModal && <ModalSession
            onClose={ () => setShowModal(false) }
            balance={ checkBalance() }
            onApprove={ handleSubmit }
            setComments={ handleComments }
          />
        }
        {
          showTransferModal && sessionDetails && sessionDetails.lastTransactions[0]?.transactionInfo[0]?.amount &&
          <TransferModal
            onClose={ () => setShowTransferModal(false) }
            userId={ sessionDetails.startedBy[0].id }
            username={ sessionDetails.startedBy[0].name }
            onApprove={ addTransaction }
          />

        }
        {
          showBalanceModal && <BalanceModal onClose={ () => setShowBalanceModal(false) } />
        }
      </div>
    </RetailPage>
  );
}

export default AdminSession;
